import React from "react";
import { useTable } from "../../Components/useTable";

const HostList = () => {
  const type = "Host";
  const headCells = [
    { id: "usercode", numeric: false, label: "RID" },
    { id: "username", numeric: false, label: "User Name" },
    { id: "pictureUrl", numeric: false, label: "Picture" },
    { id: "userbirthday", numeric: false, label: "BirthDay" },
    { id: "usercountry", numeric: false, label: "Country" },
    { id: "userlevel", numeric: false, label: "User Level" },
    { id: "totalDiamond", numeric: false, label: "Total Rcoin" },
    { id: "created", numeric: false, label: "Created at" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default HostList;
